import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=2e34864b&"
import script from "./SelectedFilters.vue?vue&type=script&lang=ts&"
export * from "./SelectedFilters.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedFilters.vue?vue&type=style&index=0&id=2e34864b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports